module.exports = __webpack_public_path__ + "img/collection-engagementRingsEssentials.3bb3847.jpg";